<template>
    <div class="main">
        <div class="bg-white">
            <div class="accountMyBox__container mx-auto text-center py-2 px-4">
                <subscription-dropdown
                    v-if="hasMultipleActiveSubscriptions"
                    :subscription-id="subscriptionId"
                    :label="label"
                    class="accountRateFlowers__subscriptionDropdown"/>
                <date-toggle
                    class="pt-2 pb-1"
                    @update-title="handleUpdateTitle"/>
            </div>
        </div>
        <div v-if="activeSchedule">
            <schedule-summary :key="activeSchedule.id"/>
        </div>
        <div v-else class="divider--container p-5 background--paper text-center">
            <div class="divider-white--top"></div>
            <h2 v-text="$t('YOUR_BOXES_STAY_TUNED')"></h2>
            <div class="divider-white--bottom"></div>
        </div>
        <div class="container mx-auto mb-8">
            <div class="w-full md:w-1/3 mx-auto text-center">
                <p v-html="$t('YOUR_BOXES_IF_EVERYTHING', {contactNumber})"></p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isInCurrentWeek } from '@/helpers/DateHelpers';
import DateToggle from '@/components/partials/account/your-boxes/DateToggle';
import ScheduleSummary from '@/components/partials/account/your-boxes/ScheduleSummary';
import SubscriptionDropdown from '@/components/partials/account/rate-my-flowers/SubscriptionDropdown';

export default {
    name: 'YourBoxes',
    data() {
        return {
            subscriptionId: null,
            scheduleDate: null,
            label: null,
            contactNumber: process.env.VUE_APP_TELEPHONE,
        };
    },
    mounted() {
        this.subscriptionId = Number(this.$route.params.subscriptionId);
        this.scheduleDate = this.$moment(this.$route.params.scheduleDate);

        this.$store.commit('cms/resetDeliveryDate');
        this.$store.dispatch('cms/fetchSchedules');
        this.$store.dispatch('subscription/fetchAllSubscriptions');
        this.$store.dispatch('address/fetchAllAddresses');
        this.$store.dispatch('cms/fetchRateableArrangements');
        this.setDefaultSchedule();
    },
    computed: {
        ...mapGetters({
            hasMultipleActiveSubscriptions: 'subscription/hasMultipleActiveSubscriptions',
            activeSubscription: 'subscription/getActiveSubscription',
            activeSchedule: 'cms/getActiveSchedule',
            schedules: 'cms/getSchedulesForActiveSubscription',
        }),
    },
    watch: {
        'activeSubscription.next_delivery_date'() {
            this.setDefaultSchedule();
        },
    },
    methods: {
        /**
         * Changes active schedule to the previous week, if flowers from the current schedule are not delivered yet.
         *
         * @returns {void}
         */
        setDefaultSchedule() {
            if (this.subscriptionId && this.scheduleDate) {
                return this.$store.dispatch('cms/setActiveScheduleWeek', this.scheduleDate.subtract(1, 'day'));
            }

            if (!this.activeSubscription || !this.activeSchedule) {
                return;
            }

            const nextDeliveryDate = this.$moment(this.activeSubscription.next_delivery_date);
            const activeScheduleStartDate = this.$moment(this.activeSchedule.deliveries_start_at);

            if (nextDeliveryDate.isAfter(this.$moment()) && isInCurrentWeek(nextDeliveryDate, activeScheduleStartDate)) {
                this.$store.dispatch('cms/decrementActiveScheduleWeek');
            }
        },

        // Handles updating the title of the subscription dropdown.
        handleUpdateTitle(title) {
            this.label = this.$t('YOUR_BOXES_DELIVERED_ON', {
                label: title,
            });
        },
    },
    components: {
        SubscriptionDropdown,
        ScheduleSummary,
        DateToggle,
    },
};
</script>
